<h2 mat-dialog-title>{{ product.name }}</h2>

<mat-dialog-content class="quick-view-content">
    <img [alt]="product.name" [src]="getImageUrl(product.imageUrls[1] || product.imageUrls[0])">

  <div class="quick-view-info">
    <p class="price">{{ product.price | currency:'USD' }}</p>
    <p class="desc">{{ product.description }}</p>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'COMMON.CLOSE' | translate }}</button>
  <button mat-flat-button color="primary" (click)="addToCart()">
    {{ 'PRODUCT.ADD_TO_CART' | translate }}
  </button>
</mat-dialog-actions>
